const TAG_FILTERS = {
  allAreas: { label: 'All areas', key: 'all' }
}

export { TAG_FILTERS }
